import { parseDecimal } from "@syla/shared/types/helpers/parsing";
import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { ValueHoldingsResponse } from "@syla/shared/types/responses/ValueHoldingsResponse";
import axios from "axios";

export async function valueHoldings(
  accountId: string,
): Promise<ValueHoldingsResponse> {
  const response = await axios.get<TransportType<ValueHoldingsResponse>>(
    `/accounts/${accountId}/wallets/value`,
  );
  return deserialise(response.data);
}

function deserialise(
  data: TransportType<ValueHoldingsResponse>,
): ValueHoldingsResponse {
  return {
    accountHoldings: data.accountHoldings.map((holding) => ({
      ...holding,
      marketValue: parseDecimal(holding.marketValue),
    })),
    walletHoldings: data.walletHoldings.map((holding) => ({
      ...holding,
      marketValue: parseDecimal(holding.marketValue),
    })),
  };
}
